import React, { Component, Fragment } from "react";
import { _ReactPixi, Sprite, withPixiApp } from "@inlet/react-pixi";
import 'bootstrap/dist/css/bootstrap.min.css';

import { connect, Provider } from "react-redux";
import { Dispatch } from "redux";

import withMobViewPanelConfiguration from "./configuration/withMobViewPanelConfiguration";

import { actions as autoplayActions } from "../../reducers/autoplayReducer";
import { actions as buttonActions } from "../../reducers/buttonPanelReducer";

import { MDBContainer, MDBRow, MDBCol, MDBTable, MDBTableBody } from "mdbreact";

import Toggle from 'react-toggle'
import Autoplay from "../autoplay/autoplay";
import Menu from "../menu/menu";

import { actions as menuActions } from "../../reducers/menuReducer";
import { actions as asyncActions } from "../../reducers/asyncServerResponseReducer";
import { actions as baseGameActions, actions as basegameActions } from "../../reducers/baseGameReducer";

interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;
}

interface IState {

}

interface IState {
    buttonSelected: any,
    showAutoplay: boolean,
    showBet: boolean,
    showSetting: boolean,
    showRules: boolean

}

interface IStateToProps {
}

interface IDispatchToProps {
}

class MobViewPanel extends Component<IProps, IState> {
    protected app: PIXI.Application;

    protected mobViewPanelContainer: any;
    protected headingContainerBgColor: any;
    protected mainContainerBgColor: any;
    protected textColor: any;
    protected insideBorderColor: any;
    protected bottomButtonBarBgColor: any;
    protected enableAutoplayButtonX: number;
    protected enableAutoplayButtonY: number;
    protected disableAutoplayButtonX: number;
    protected disableAutoplayButtonY: number;
    protected enableBetButtonX: number;
    protected enableBetButtonY: number;
    protected disableBetButtonX: number;
    protected disableBetButtonY: number;
    protected enableSettingButtonX: number;
    protected enableSettingButtonY: number;
    protected disableSettingButtonX: number;
    protected disableSettingButtonY: number;
    protected enableRuleButtonX: number;
    protected enableRuleButtonY: number;
    protected disableRuleButtonX: number;
    protected disableRuleButtonY: number;
    protected enableCloseButtonX: number;
    protected enableCloseButtonY: number;

    constructor(props: IProps) {
        super(props);

        this.app = props.app;
        this.mobViewPanelContainer = React.createRef();
        this.state = {
            buttonSelected: "b1",
            showAutoplay: true,
            showBet: false,
            showSetting: false,
            showRules: false


        }
        this.headingContainerBgColor = '#93fd01'
        this.textColor = '#f5f3ec'
        this.mainContainerBgColor = '#000000'
        this.insideBorderColor = '#808080'
        this.bottomButtonBarBgColor = '#272424'

        this.enableAutoplayButtonX = -304;
        this.enableAutoplayButtonY = -85;
        this.disableAutoplayButtonX = -263;
        this.disableAutoplayButtonY = -85;

        this.enableBetButtonX = -366
        this.enableBetButtonY = -43;
        this.disableBetButtonX = -341;
        this.disableBetButtonY = -1;

        this.enableSettingButtonX = -345
        this.enableSettingButtonY = -85;
        this.disableSettingButtonX = -325;
        this.disableSettingButtonY = -43;

        this.enableRuleButtonX = -378
        this.enableRuleButtonY = -1;
        this.disableRuleButtonX = -386;
        this.disableRuleButtonY = -85;

        this.enableCloseButtonX = -417
        this.enableCloseButtonY = -84;
    }

    reset() {
        this.setState((prevState) => {
            return {
                ...prevState,
                buttonSelected: "b1",
                showAutoplay: true,
                showBet: false,
                showRules: false,
                showSetting: false
            }
        })
    }

    onClick(name: any) {
        this.setState((prevState) => {
            return {
                ...prevState,
                buttonSelected: name

            }
        })

    }

    showBet() {
        this.setState((prevState) => {
            return {
                ...prevState,
                showAutoplay: false,
                showBet: true,
                showRules: false,
                showSetting: false
            }
        })
    }

    showRules() {
        this.setState((prevState) => {
            return {
                ...prevState,
                showAutoplay: false,
                showBet: false,
                showRules: true,
                showSetting: false
            }
        })
    }

    showSetting() {
        this.setState((prevState) => {
            return {
                ...prevState,
                showAutoplay: false,
                showBet: false,
                showRules: false,
                showSetting: true
            }
        })
    }

    showAutoplay() {
        this.setState((prevState) => {
            return {
                ...prevState,
                showAutoplay: true,
                showBet: false,
                showRules: false,
                showSetting: false

            }
        })
    }

    componentDidMount() {


    }


    componentWillUnmount() {

    }


    render() {

        if (!this.props.showAutoplay) {
            return (<></>)
        }
        let { showAutoplay, showBet, showRules, showSetting } = this.state;
        let autoplayButtonX, autoplayButtonY, betButtonX, betButtonY, settingButtonX, settingButtonY, rulesButtonX,
            rulesButtonY;
        if (showAutoplay) {
            autoplayButtonX = this.enableAutoplayButtonX
            autoplayButtonY = this.enableAutoplayButtonY
        } else {
            autoplayButtonX = this.disableAutoplayButtonX
            autoplayButtonY = this.disableAutoplayButtonY
        }
        if (showBet) {
            betButtonX = this.enableBetButtonX
            betButtonY = this.enableBetButtonY
        } else {
            betButtonX = this.disableBetButtonX
            betButtonY = this.disableBetButtonY
        }
        if (showSetting) {
            settingButtonX = this.enableSettingButtonX
            settingButtonY = this.enableSettingButtonY
        } else {
            settingButtonX = this.disableSettingButtonX
            settingButtonY = this.disableSettingButtonY
        }
        if (showRules) {
            rulesButtonX = this.enableRuleButtonX
            rulesButtonY = this.enableRuleButtonY
        } else {
            rulesButtonX = this.disableRuleButtonX
            rulesButtonY = this.disableRuleButtonY
        }
        let PROPS_TO_SEND_Autoplay = {


            langObj: this.props.langObj,

        }
        return (
            <div className="mobViewMainContainer" style={{

                top: '0%',
                left: '0%',
                height: '100%',
                width: '100%',
                backgroundColor: this.mainContainerBgColor
            }}>

                <MDBContainer style={{
                    height: '100%',
                }}>

                    <MDBRow style={{

                        height: '20%',

                    }}>
                        <MDBCol size="12" sm="12" lg="12"
                            style={{ backgroundColor: this.mainContainerBgColor, border: 'none' }}>
                            {showAutoplay && <h2 style={{
                                position: 'relative', top: '17%',
                                color: this.textColor, fontSize: '23px', textAlign: 'center', fontWeight: 'bold',
                            }}>{this.props.langObj["autoplayText_5"]}</h2>}
                            {showBet && <h2 style={{
                                position: 'relative', top: '17%',
                                color: this.textColor, fontSize: '23px', textAlign: 'center', fontWeight: 'bold',
                            }}>{this.props.langObj["mobViewPanel_Text_1"]}</h2>}
                            {showSetting && <h2 style={{
                                position: 'relative', top: '17%',
                                color: this.textColor, fontSize: '23px', textAlign: 'center', fontWeight: 'bold',
                            }}>{this.props.langObj["desktopSettingPanel_Text_1"]}</h2>}
                            {showRules && <h2 style={{
                                position: 'relative', top: '17%',
                                color: this.textColor, fontSize: '23px', textAlign: 'center', fontWeight: 'bold',
                            }}>{this.props.langObj["mobViewPanel_Text_2"]}</h2>}
                        </MDBCol>
                    </MDBRow>

                    <MDBRow style={{

                        height: '60%',

                    }}>
                        <MDBCol size="12" sm="12" lg="12"
                            style={{ backgroundColor: this.mainContainerBgColor, border: 'none' }}>
                            <MDBTable scrollY>
                                <MDBTableBody>
                                    {showAutoplay && <tr>
                                        <td colSpan={4} style={{ borderTop: "1px solid" + this.insideBorderColor }}>
                                            {showAutoplay && <Autoplay {...PROPS_TO_SEND_Autoplay}></Autoplay>}
                                        </td>
                                    </tr>}
                                    {showBet && <tr>
                                        <td colSpan={4} style={{ borderTop: "1px solid" + this.insideBorderColor }}>
                                            {showBet && <Menu  {...PROPS_TO_SEND_Autoplay}></Menu>}
                                        </td>
                                    </tr>}

                                    {showSetting && <tr>
                                        <td style={{
                                            borderTop: '1px solid' + this.insideBorderColor,
                                            borderBottom: '1px solid' + this.insideBorderColor
                                        }}>
                                            <MDBContainer>
                                                <MDBRow>
                                                    <MDBCol size="5" sm="3" style={{
                                                        backgroundColor: this.mainContainerBgColor,
                                                        border: 'none'
                                                    }}>
                                                        <Toggle defaultChecked={true} onChange={() => {

                                                        }} />
                                                    </MDBCol>

                                                    <MDBCol size="7" sm="4" style={{
                                                        backgroundColor: this.mainContainerBgColor,
                                                        border: 'none'
                                                    }}>
                                                        <h2 style={{
                                                            color: this.textColor,
                                                            fontSize: '15px',
                                                            fontWeight: 'bold'
                                                        }}>{this.props.langObj["desktopSettingPanel_Text_5"]}</h2>
                                                    </MDBCol>
                                                </MDBRow>
                                                <MDBRow>
                                                    <MDBCol size="5" sm="3" style={{
                                                        backgroundColor: this.mainContainerBgColor,
                                                        border: 'none'
                                                    }}>
                                                        <Toggle defaultChecked={false} onChange={() => {

                                                        }} />
                                                    </MDBCol>

                                                    <MDBCol size="7" sm="4" style={{
                                                        backgroundColor: this.mainContainerBgColor,
                                                        border: 'none'
                                                    }}>
                                                        <h2 style={{
                                                            color: this.textColor,
                                                            fontSize: '15px',
                                                            fontWeight: 'bold'
                                                        }}>{this.props.langObj["desktopSettingPanel_Text_2"]}</h2>
                                                    </MDBCol>
                                                </MDBRow>
                                            </MDBContainer>
                                        </td>
                                    </tr>}
                                    {showRules && <tr>
                                        <td colSpan={4} style={{ borderTop: "1px solid" + this.insideBorderColor }}>
                                            {/*{showRules && <MobilePaytable langObj ={this.props.langObj}></MobilePaytable>}*/}
                                        </td>
                                    </tr>}
                                </MDBTableBody>
                            </MDBTable>

                        </MDBCol>
                    </MDBRow>

                    <MDBRow center={true} style={{
                        height: '20%', backgroundColor: this.bottomButtonBarBgColor
                    }}>
                        <MDBCol size="3" sm="2" style={{
                            backgroundColor: this.bottomButtonBarBgColor,
                            border: 'none',
                            maxWidth: '20%',
                            alignSelf: 'center'
                        }}>
                            <button className="mobViewButtons" style={{
                                width: '39px',
                                height: '40px',
                                backgroundPositionX: autoplayButtonX,
                                backgroundPositionY: autoplayButtonY,
                                border: 'none',
                                outline: 'none'
                            }}
                                onClick={() => {
                                    this.onClick("b1")
                                    this.showAutoplay();
                                }}
                            ></button>
                        </MDBCol>
                        <MDBCol size="3" sm="2" style={{
                            backgroundColor: this.bottomButtonBarBgColor,
                            border: 'none',
                            maxWidth: '20%',
                            alignSelf: 'center'
                        }}>
                            <button className="mobViewButtons" style={{
                                width: '39px',
                                height: '40px',
                                backgroundPositionX: betButtonX,
                                backgroundPositionY: betButtonY,
                                border: 'none',
                                outline: 'none'

                            }}
                                onClick={() => {
                                    this.onClick("b2")
                                    this.showBet();
                                    this.props.showMenuUI();
                                }}
                            ></button>
                        </MDBCol>
                        <MDBCol size="3" sm="2" style={{
                            backgroundColor: this.bottomButtonBarBgColor,
                            border: 'none',
                            maxWidth: '20%',
                            alignSelf: 'center'
                        }}>
                            <button className="mobViewButtons" style={{
                                width: '39px',
                                height: '40px',
                                backgroundPositionX: settingButtonX,
                                backgroundPositionY: settingButtonY,
                                border: 'none',
                                outline: 'none'

                            }}
                                onClick={() => {
                                    this.onClick("b3")
                                    this.showSetting();
                                }}
                            ></button>
                        </MDBCol>
                        <MDBCol size="3" sm="2" style={{
                            backgroundColor: this.bottomButtonBarBgColor,
                            border: 'none',
                            maxWidth: '20%',
                            alignSelf: 'center'
                        }}>
                            <button className="mobViewButtons" style={{
                                width: '29px',
                                height: '40px',
                                backgroundPositionX: rulesButtonX,
                                backgroundPositionY: rulesButtonY,
                                border: 'none',
                                outline: 'none'

                            }}
                                onClick={() => {
                                    this.onClick("b4")
                                    this.showRules();
                                }}
                            ></button>

                        </MDBCol>
                        <MDBCol size="3" sm="2" style={{
                            backgroundColor: this.bottomButtonBarBgColor,
                            border: 'none',
                            maxWidth: '20%',
                            alignSelf: 'center'
                        }}>
                            <button className="mobViewButtons" style={{
                                width: '39px',
                                height: '40px',
                                backgroundPositionX: -417,
                                backgroundPositionY: -84,
                                border: 'none',
                                outline: 'none'

                            }}
                                onClick={() => {
                                    this.onClick("b5")
                                    this.props.hideAutoplay();
                                    this.props.hideMenuUI();
                                    this.props.setAllButtonEnable();
                                    this.reset();
                                }}
                            ></button>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </div>)
    }

}


export default withPixiApp(connect(
    (state: Pick<IStore, 'autoplayState' | 'menuState' | 'applicationState'>): IStateToProps =>
    ({
        showAutoplay: state.autoplayState.showAutoplay,
        autoplayStopped: state.autoplayState.autoplayStopped,
        resizeWidth: state.applicationState.resizeWidth,
        resizeHeight: state.applicationState.resizeHeight,
        scaleX: state.applicationState.scaleX,
        scaleY: state.applicationState.scaleY,

    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        hideMenuUI: (): any => dispatch(menuActions.hideMenuUI()),
        showMenuUI: (): any => dispatch(menuActions.showMenuUI()),
        hideAutoplay: (): any => dispatch(autoplayActions.hideAutoplayUI()),
        setAutoplay: (autoplayCount: number): any => dispatch(autoplayActions.setAutoplayCount(autoplayCount)),
        startAutoplay: (): any => dispatch(baseGameActions.startAutoplay()),
        setApplicationAutoplayCount: (autoplaycount: number): any => dispatch(baseGameActions.setApplicationAutoplayCount(autoplaycount)),
        getApplicationSpinResponse: (): any => dispatch(asyncActions.getApplicationSpinResponse()),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        stoppedAutoplayUI: (autoplayStopped: boolean): any => dispatch(autoplayActions.stoppedAutoplayUI(autoplayStopped)),
    }))(withMobViewPanelConfiguration(MobViewPanel)));